import { Box } from "@mui/material";
import useLoginWithSocial from "../../hooks/useLoginWithSocial";
import { GoogleLogin } from "@react-oauth/google";

const ActionLoginSocial = ({ onClick = () => { }, onSuccess = (userDetail) => userDetail, onFailure = (errors) => errors }) => {
  const { loginWithGoogle } = useLoginWithSocial()


  return (
    <>
      <hr />
      <div className="text-center">
        <span>Atau</span>
      </div>
      <Box sx={{
        display: 'flex',
        justifyContent: 'center',
        margin: '20px 0'
      }}>
        <button className="btn btn-link p-0 btn-google" id="btn_google" style={{
          transform: 'scale(1.25)',

        }} onClick={onClick}>
          <GoogleLogin
            onError={(errors) => {
              if (onFailure) {
                onFailure(errors)
              }
            }}
            type="standard"
            shape="pill"
            containerProps={{
              style: {
                minWidth: 'none'
              }
            }}
            size="large"
            logo_alignment="center"
            onSuccess={async (response) => {
              loginWithGoogle(response.credential)
              if (onSuccess) {
                onSuccess(response)
              }
            }}
          />
        </button>
      </Box>
    </>
  );
}

export default ActionLoginSocial;